import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { OnboardingDialogClose } from '@shared/shared/enums/onboarding-dialog-close';
import { CustomAssetImage } from '@shared/shared/interfaces/custom-assets.interfaces';
import { getAllCustomAssets } from '@shared/store';
import * as MemberProfileStore from '@shared/store/member-profile';
import * as UserStore from '@shared/store/user';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ten-marketing-popup',
  templateUrl: './marketing-popup.component.html',
  styleUrls: ['./marketing-popup.component.scss'],
  standalone: true,
  imports: [AsyncPipe, NgIf, NgClass, MatLegacyButtonModule, TranslateModule],
})
export class MarketingPopupComponent implements OnDestroy {
  public buttonTypes = OnboardingDialogClose;
  public customVariables$ = this.customVariablesService.variables;
  public user_authenticated$: Observable<boolean> = this.ngrxStore.select(UserStore.getUserAuthenticated);
  private unsubscribe$ = new Subject<void>();
  public step = 1;
  public marketingImage$: Observable<CustomAssetImage>;

  constructor(
    public dialogRef: MatDialogRef<MarketingPopupComponent>,
    private customVariablesService: CustomisableVariablesService,
    private ngrxStore: Store<MemberProfileStore.MemberProfileState | UserStore.UserState>
  ) {
    // if the user logs out close the modal
    this.user_authenticated$.pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      if (!res) {
        this.dialogRef.close();
      }
    });
    this.marketingImage$ = this.ngrxStore
      .select(getAllCustomAssets)
      .pipe(map((assets) => assets.onboarding_tutorial_marketing_opt_in_slide));
  }

  public clickButton(type: string) {
    if (!type) return;

    switch (type) {
      case this.buttonTypes.DISAGREED:
        this.ngrxStore.dispatch(
          new MemberProfileStore.UpdateMemberProfile({
            ten_opt_in: false,
          })
        );
        this.dialogRef.close(type);
        break;

      case this.buttonTypes.CONTINUE:
        this.dialogRef.close(type);
        break;

      default:
        this.step = 2;
        this.ngrxStore.dispatch(
          new MemberProfileStore.UpdateMemberProfile({
            ten_opt_in: true,
          })
        );
        break;
    }
  }

  public ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
